import { connect } from 'react-redux';
import { toggleLogin } from 'pap/ducks/workflow';
import LazyRegistration from 'pap/components/common/input_fields/lazy_registration';

const mapStateToProps = ({ pap }) => {
  return {
    showingLogin: pap.workflow.showingLogin
  };
}

export default connect(mapStateToProps, {
  onToggleLogin: toggleLogin
})(LazyRegistration);
